import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  comments: [],
  objective: {},
  objectives: [],
  lwobjectives: [],
  objectivesByPlan: [],
  wobjectives: [],
  olwobjectives: [],
  contobjectives: []
}

const mutations = {  
  SET_COMMENTS (state, payload) {
    state.comments = payload
  },
  SET_OBJECTIVE (state, payload) {
    state.objective = payload
  },
  SET_OBJECTIVES (state, payload) {
    state.objectives = payload
  },
  SET_OBJECTIVES_BY_PLAN (state, payload) {
    state.objectivesByPlan = payload
  },
  SET_LWOBJECTIVES (state, payload) {
    state.lwobjectives = payload
  },
  SET_WOBJECTIVES (state, payload) {
    state.wobjectives = payload
  },
  SET_OLWOBJECTIVES (state, payload) {
    state.olwobjectives = payload
  },
  SET_CONTOBJECTIVES (state, payload) {
    state.contobjectives = payload
  },
  ADD_COMMENT (state, payload) {
    state.comments.push(payload)
  },
  ADD_OBJECTIVE (state, payload) {
    state.objectives.push(payload)
  },
  CLEAN (state) {
    state.comments = []
    state.objective = {}
    state.objectives = []
    state.lwobjectives = []
    state.wobjectives = []
    state.olwobjectives = []
    state.contobjectives = []
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  createObjective(context, data) {
    return Vue.http.post(`${env.API}/api/objective`, data)    
      .then((response) => {        
        context.commit('SET_OBJECTIVE', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getObjectiveById: (context, id) => {
    return Vue.http.get(`${env.API}/api/objective/${id}`)    
      .then((response) => {        
        context.commit('SET_OBJECTIVE', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getObjectiveByWeek: (context, data) => {
    return Vue.http.post(`${env.API}/api/objective/by-week`, data)    
      .then((response) => {        
        context.commit('SET_WOBJECTIVES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getObjectiveOpenLastWeek: (context, data) => {
    return Vue.http.post(`${env.API}/api/objective/open-last-week`, data)    
      .then((response) => {        
        context.commit('SET_LWOBJECTIVES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getObjectiveByLastWeek: (context, data) => {
    return Vue.http.post(`${env.API}/api/objective/last-week`, data)    
      .then((response) => {        
        context.commit('SET_LWOBJECTIVES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getObjectiveByPlan: (context, data) => {
    return Vue.http.post(`${env.API}/api/objective/by-plan`, data)    
      .then((response) => {        
        context.commit('SET_OBJECTIVES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getObjectiveByMeeting: (context, id) => {
    return Vue.http.get(`${env.API}/api/objective/by-meeting/${id}`)    
      .then((response) => {        
        context.commit('SET_OBJECTIVES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getObjectiveByTracing: (context, id) => {
    return Vue.http.get(`${env.API}/api/objective/by-tracing/${id}`)    
      .then((response) => {        
        context.commit('SET_OBJECTIVES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  commentsById: (context, id) => {
    return Vue.http.get(`${env.API}/api/objective/comments?${id}`)    
      .then((response) => {        
        context.commit('SET_COMMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  addComment: (context, data) => {
    return Vue.http.post(`${env.API}/api/objective/comments`, data)    
      .then((response) => {        
        context.commit('ADD_COMMENT', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  close: (context, data) => {    
    return Vue.http.put(`${env.API}/api/objective/close/${data.id}`, data)    
      .then((response) => {                
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  continue: (context, data) => {
    return Vue.http.put(`${env.API}/api/objective/move/${data.id}`, data)    
      .then((response) => {        
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getContObjByPlan: (context, data) => {
    return Vue.http.post(`${env.API}/api/objective/cont-by-plan`, data)    
      .then((response) => {        
        context.commit('SET_OBJECTIVES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },  
  getObjByPlanForList: (context, id) => {
    return Vue.http.get(`${env.API}/api/objective/by-plan-for-list/${id}`)    
      .then((response) => {        
        context.commit('SET_OBJECTIVES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateObjective: (context, data) => {
    const { id, accomplished, state } = data
    return Vue.http.put(`${env.API}/api/objective/${id}`, { accomplished, state })    
      .then((response) => {        
        context.commit('SET_OBJECTIVES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateBusiness: (context, data) => {
    return Vue.http.put(`${env.API}/api/objective/set-business/multiple`, data)    
    .then((response) => {        
      return response.body.success
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  deleteObjective: (context, id) => {
    return Vue.http.delete(`${env.API}/api/objective/${id}`)
  },
  setLWObjects: (context, data) => {
    return context.commit('SET_LWOBJECTIVES', data)
  },
  setContObjects: (context, data) => {
    return context.commit('SET_CONTOBJECTIVES', data)
  },
  cleanStore: (context) => {
    context.commit('CLEAN')
    return
  },
  updateObjectComment: (context, data) => {
    return Vue.http.put(`${env.API}/api/objective/comments-edit/${data.id}`, data)    
    .then((response) => {        
      context.commit('SET_OBJECTIVE', response.body.message)
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  addObjCPM: (context, data) => {
    return Vue.http.post(`${env.API}/api/objective/add-objective-cpm`, data)    
      .then((response) => {        
        context.commit('SET_OBJECTIVE', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getComments: (state) => state.comments,
  getObjective: (state) => state.objective,
  getObjectives: (state) => state.objectives,
  getWObjectives: (state) => state.wobjectives,
  getLWObjectives: (state) => state.lwobjectives,
  getContObjectives: (state) => state.contobjectives,
  getObjectivesByPlan: (state) => state.objectivesByPlan
}

export const objective = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/objective.js